module.exports = __webpack_public_path__ + "static/media/sf_1.a68bb23a.svg";